import { styled, FormControlLabel } from '@mui/material';

export const StyledFormControlLabel = styled(FormControlLabel)`
  margin: 12px 0;
`;
